import { Radio } from '@safedns/skydns-ui-react-lib';

import styles from './UsersAssignedFilter.module.scss';

const UsersAssignedFilter = ({ onChange, value }) => {
  const options = [
    { value: 'all', label: 'Все' },
    { value: 'unassigned', label: 'Неназначенные' },
    { value: 'assigned', label: 'Назначенные' },
  ];

  return (
    <div className={styles.container}>
      <span className={styles.label}>Показать:</span>
      <div className={styles.options}>
        {options.map((opt) => (
          <Radio
            key={opt.value}
            id={`filter-${opt.value}`}
            name="users-assigned-filter"
            value={opt.value}
            label={opt.label}
            isChecked={value === opt.value}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  );
};

export default UsersAssignedFilter;
